/**
 * ENFAMI Cart — upsell quick-add (rafraîchit le drawer Horizon)
 */
(function () {
  'use strict';

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  async function addVariant(variantId, btn) {
    if (!variantId) return;
    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    }

    try {
      var res = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      if (!res.ok) throw new Error('add failed');

      var cartRes = await fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } });
      var cart = cartRes.ok ? await cartRes.json() : null;

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart || undefined,
            sourceId: 'enfami-upsell',
            data: {
              source: 'enfami-upsell',
              itemCount: 1,
              variantId: String(variantId),
              sections: {},
            },
          },
        })
      );

      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
      }
    } catch (err) {
      console.warn('[enfami-cart] upsell add failed', err);
    } finally {
      if (btn) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ef-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    addVariant(btn.getAttribute('data-variant-id'), btn);
  });
})();
